import React from 'react';
import { Modal } from '@avangard/ui/core';

import { ChangePasswordForm } from '@modules/auth/organisms';

import type { ModalProps } from '@avangard/ui/core';

type ChangePasswordFormModalProps = Omit<ModalProps, 'title' | 'children'>;

const ChangePasswordFormModal = (props: ChangePasswordFormModalProps) => {
    const { onClose, ...otherProps } = props;

    return (
        <Modal title='Смена пароля' onClose={onClose} {...otherProps}>
            <ChangePasswordForm onCancel={onClose} />
        </Modal>
    );
};

export { ChangePasswordFormModal };
